import repeat from 'lodash/repeat';
import classNames from 'classnames';

import MarkSafe from 'topmeteo/general/components/MarkSafe';

const NonBreakableSpace = '&nbsp;';

const applyLevel = (title, level, available) => repeat(NonBreakableSpace, level * 4) + (available ? '' : '€ ') + title;

const Option = ({id, title, level, available}) => (
    <MarkSafe
        Element="option"
        key={id}
        value={id}
        className={classNames('region', {available})}
        html={applyLevel(title, level, available)}
    />
);

export default Option;
